"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.debounce = debounce;

/**
 * @description executes the function if there was no new event in $wait milliseconds
 * @summary
 * Returns a new method that is only executed, when not being called again after
 * a given number of milliseconds.
 * This is usefull, if you only want to execute an resource intensive action
 * once the user has stopped interacting with the page.
 *
 * @example
 * import { debounce } from '@nimus/event-utility'
 *
 * // The method `doSomethingResourceIntensive` will only be executed once
 * // the user has stopped scrolling for at least 150ms instead of on every
 * // scroll.
 * window.addEventListener('scroll', debounce(
 *    () => doSomethingResourceIntensive(),
 *    150
 * ));
 *
 * @param {Function} func - The method that should be
 * @param {number} wait - The amount to debounce by. This is the amount of time
 *        that is waited for additional events before executing the function.
 *        Increase this timeout to prevent a lot of computational overhead,
 *        decrease this timeout to ensure quick response times.
 * @returns {Function} - Function that is only executed once a 'flood of events'
 *          has stopped.
 */
function debounce(func, wait) {
    var timeout = void 0;
    return function () {
        var args = arguments;
        var later = function later() {
            timeout = null;
            func.apply(null, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/event-utility/src/debounce.js
// module id = 124
// module chunks = 5